<script>
export default {
  render() {
    return this.$slots.default({});
  },
};
</script>